export default __webpack_public_path__ + "static/media/milestone 3800.b4f78299.svg";